import { render, staticRenderFns } from "./error-store.vue?vue&type=template&id=bafd7fe4&"
import script from "./error-store.vue?vue&type=script&lang=js&"
export * from "./error-store.vue?vue&type=script&lang=js&"
import style0 from "./error-store.vue?vue&type=style&index=0&id=bafd7fe4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports